import React from "react";
import { OrganisationOUT } from "api-client";
import useSidebarMenu from "../useSidebarMenu";
import DashboardMenu, { DashboarMenuItem } from "./DashboardMenu";

const ManufacturerDashboards = ({
  organisation,
}: {
  organisation: OrganisationOUT;
}) => {
  const {
    EPDListMenuItem,
    ProductListMenuItem,
    manufacturerDashboardMenuItem,
  } = useSidebarMenu(organisation.id);

  const menuItems: DashboarMenuItem[] = [
    manufacturerDashboardMenuItem,
    ProductListMenuItem,
    EPDListMenuItem,
  ];

  return <DashboardMenu menuItems={menuItems} />;
};

export default ManufacturerDashboards;
